<div>
    <span *ngIf="required">*</span>
    <span *ngIf="required" class="cdk-visually-hidden">This item is required.</span>
    <span class="mat-body-2">
        <ng-content class="mat-body-2"></ng-content>
    </span>
    <!-- <span class="mat-body-2" [innerHTML]="LabelText | safeHTML"></span> -->
</div>